const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/priority/$kind/$uuid.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// Named $uuid (not $id) deliberately: useChatParams() reads `params.uuid` via
// an ambient useParams({ strict: false }), so any route segment literally
// named $uuid makes DMs' existing ChatRoom tree work here with zero changes
// to it -- see PriorityInboxDetailPanel's `dms` case.
export const Route = createFileRoute("/_protected/settings/inbox/priority/$kind/$uuid")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});